import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import NoSsr from '@mui/material/NoSsr';

import Main from 'layouts/Main';
import Container from 'components/Container';
import {
  Welcome,
  Goby,
  Process,
  Nike2,
  Larq,
  Nike,
  Trek,
  Curology,
  Reviews,
  Contact,

} from './components';

const AboutUs = () => {
  useEffect(() => {
    const jarallaxInit = async () => {
      const jarallaxElems = document.querySelectorAll('.jarallax');
      if (!jarallaxElems || (jarallaxElems && jarallaxElems.length === 0)) {
        return;
      }

      const { jarallax } = await import('jarallax');
      jarallax(jarallaxElems, { speed: 0.2 });
    };

    jarallaxInit();
  });

  const scrollTo = (id) => {
    setTimeout(() => {
      const element = document.querySelector(`#${id}`);
      if (!element) {
        return;
      }

      window.scrollTo({ left: 0, top: element.offsetTop, behavior: 'smooth' });
    });
  };

  const theme = useTheme();



  return (
    <Main>
    
       <br />
       <Container maxWidth={0.9} paddingTop={'0 !important'}>
          <Reviews />
        </Container>
       
        <Container  maxWidth={0.77}  paddingTop={'0 !important'}>
          <Process />
        </Container>
        {/* <br />
    <br />

        <Container maxWidth={0.9} paddingTop={'0 !important'}>
          <Goby />
        </Container>
        <br />
    <br /> */}
        
          <Container  maxWidth={0.77}  paddingTop={'0 !important'}>
          <Curology />
          </Container>
        
   
        {/* <Container  maxWidth={0.9}  paddingTop={'0 !important'}>
          <Nike/>
        </Container>    

        <Container  maxWidth={0.9} paddingTop={{ md: 6 }}>
          <Trek/>
        </Container>
        <br />
     
        <Container maxWidth={0.9} paddingY={'0 !important'}>
          <Larq />
        </Container>
        <br /> */}
       
        {/* <Container  maxWidth={0.9} paddingY={'0 !important'}>
          <Nike2 />
        </Container> */}
    
      
    </Main>
  );
};

export default AboutUs;
